import { Navigate } from 'react-router-dom';
import usePermission from '@/hooks/usePermission';
import { getDefaultRoute } from '@/utils';
import { Spin } from 'antd';
import { useUserStore } from '@/stores';

/**
 * Smart redirect component that navigates to the appropriate default page
 * based on user permissions
 */
const DefaultRedirect = () => {
  const { hasPermission } = usePermission();
  const user = useUserStore((state) => state.user);

  // Wait for user data to load before redirecting
  const permissionsLoaded = user?.permissions !== undefined;

  if (!user || !permissionsLoaded) {
    return (
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          minHeight: '50vh',
        }}
      >
        <Spin size='large' />
      </div>
    );
  }

  const defaultRoute = getDefaultRoute(hasPermission);

  return <Navigate to={defaultRoute} replace />;
};

export default DefaultRedirect;
